import { createSlice } from '@reduxjs/toolkit';
import { httpGet, httpPost, httpDelete } from '../../util/Rest';

const initialData = {
  workQueueData: [],
  workQueueGeneratedData: [],
  workQueueList: [],
  changedWorkQueueList: [],
  workQueueObjSplitScreen: {},
  workQueueListStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  workQueue: [],
  workQueueStatus: null,
  workQueueListData: {},
  workQueueRedirectData: {},
  splitWorkQueueData: [],
  deleteAccountStatus: null,
  redirectColumnData: {
    column2: [
      {
        field: 'accountNumber',
        title: 'Account Number',
      },
    ],
  },
};

const slice = createSlice({
  name: 'workQueue',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchSuccess: (state, action) => {
      state.isLoading = false;
      state.successMsg = action.payload;
    },
    getWorkQueueData: (state, action) => {
      state.workQueueData = action.payload.resultObject;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getWorkQueueGeneratedData: (state, action) => {
      state.workQueueGeneratedData = action.payload.resultObject;
      state.isLoading = false;
      state.errorMsg = null;
    },
    workQueueListData: (state, action) => {
      state.workQueueListData = action.payload.response;
      state.isLoading = false;
      state.errorMsg = null;
    },
    setSplitWorkQueueData: (state, action) => {
      state.workQueueList = (action?.payload || []).map((item) => item.accountNumber);
      state.splitWorkQueueData = action.payload;
    },
    setRedirectColumnData: (state, action) => {
      state.redirectColumnData = action.payload;
    },
    resetworkQueueListData: (state, action) => {
      state.workQueueListData = {};
      state.isLoading = false;
      state.errorMsg = null;
    },
    getWorkQueueList: (state, action) => {
      if (action.payload.response.resultObjects) {
        state.workQueueObjSplitScreen = action?.payload?.response;
      } else {
        state.workQueueList = (action?.payload?.response || []).map((item) => item.accountNumber);
      }
      state.workQueueListStatus = action?.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
    },
    changeWorkQueueList: (state, action) => {
      state.changedWorkQueueList = (action?.payload.response.resultObjects || []).map(
        (item) => item.accountNumber,
      );
      state.workQueueListStatus = action?.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
    },
    workQueueReset: (state, action) => {
      state.workQueue = [];
      state.isLoading = false;
      state.workQueueStatus = null;
      state.errorMsg = null;
    },
    getWorkQueue: (state, action) => {
      state.workQueue = action?.payload?.response.resultObjects;
      state.isLoading = false;
      state.workQueueStatus = action?.payload?.status;
      state.errorMsg = null;
    },
    addWorkQueueRedirectData: (state, action) => {
      state.workQueueRedirectData = action.payload;
    },
    getAccountRemoveStatus: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.deleteAccountStatus = action?.payload?.status;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
    resetData: (state) => {
      state.workQueueData = [];
      state.workQueueList = [];
      state.changedWorkQueueList = [];
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
    resetWorkQueueRedirectData: (state) => {
      state.workQueueRedirectData = {};
    },
    resetworkQueueListStatus: (state) => {
      state.workQueueListStatus = null;
    },
    resetWorkQueueObjSplitScreen: (state) => {
      state.workQueueObjSplitScreen = {};
    },
    resetRemoveAccountStatus: (state) => {
      state.deleteAccountStatus = null;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  getWorkQueueData,
  getWorkQueueList,
  fetchStart,
  fetchError,
  fetchSuccess,
  resetData,
  resetworkQueueListStatus,
  getWorkQueue,
  getWorkQueueStatus,
  workQueueReset,
  workQueueListData,
  resetworkQueueListData,
  getWorkQueueGeneratedData,
  addWorkQueueRedirectData,
  resetWorkQueueRedirectData,
  setSplitWorkQueueData,
  redirectColumnData,
  setRedirectColumnData,
  getAccountRemoveStatus,
  resetRemoveAccountStatus,
  changeWorkQueueList,
  resetWorkQueueObjSplitScreen,
  resetMsg,
} = slice.actions;

export const fetchWorkQueueGeneratedBy = (data) => {
  return (dispatch) => {
    httpPost(`workqueu/getall/workqueue/generatedBy`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getWorkQueueGeneratedData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchWorkQueueData = (data) => {
  return (dispatch) => {
    httpPost(`workqueu/getall/workqueue/all`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getWorkQueueData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchWorkQueueList = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`workqueu/find/accountnumber/${id}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getWorkQueueList(data));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchWorkQueueListData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`workqueu/find/all/workqueue`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(workQueueListData(data));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchWorkQueueListAllData = (data, deleteAccount) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`workqueu/find/all/workqueue`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          if (deleteAccount) {
            dispatch(changeWorkQueueList(data));
          } else {
            dispatch(getWorkQueueList(data));
          }
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchWorkQueue = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`workqueu/find/all/workqueue`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getWorkQueue(data));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postWqActivity = (data) => {
  return (dispatch) => {
    httpPost(`workqueu/save/userwqactivity`, data).catch((error) => {
      dispatch(fetchError(error.message));
    });
  };
};

export const postWqAccountActivity = (data) => {
  return (dispatch) => {
    httpPost(`workqueu/save/userwqaccount`, data).catch((error) => {
      dispatch(fetchError(error.message));
    });
  };
};
export const resetWorkQueue = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
export const resetStatusWorkQueueList = () => {
  return (dispatch) => {
    dispatch(resetworkQueueListStatus());
  };
};

export const resetWorkQueueList = () => {
  return (dispatch) => {
    dispatch(resetworkQueueListData());
  };
};

export const deleteWorkQueueByAccountNumber = ({ accountNumber, isDirty }) => {
  return (dispatch) => {
    const workQueueId = sessionStorage.getItem('workQueueId')
      ? Number(sessionStorage.getItem('workQueueId'))
      : '';
    if (accountNumber && workQueueId && isDirty) {
      dispatch(fetchStart());
      httpDelete(`workqueu/delete/workqueuebyaccountnumber/${accountNumber}/${workQueueId}`)
        .then((data) => {
          if (data && data.status && data.status === 200) {
            // localStorage.removeItem("workQueueId");
            dispatch(getAccountRemoveStatus(data));
          } else {
            dispatch(fetchError(data.message));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
};
